import { render, staticRenderFns } from "./TabVroid.vue?vue&type=template&id=43f5a1a4&scoped=true&"
import script from "./TabVroid.vue?vue&type=script&lang=ts&"
export * from "./TabVroid.vue?vue&type=script&lang=ts&"
import style0 from "./TabVroid.vue?vue&type=style&index=0&id=43f5a1a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f5a1a4",
  null
  
)

export default component.exports